import { render } from "./DriverStatusApiDocsPage.vue?vue&type=template&id=1cc1fc78&scoped=true&ts=true"
import script from "./DriverStatusApiDocsPage.vue?vue&type=script&lang=ts"
export * from "./DriverStatusApiDocsPage.vue?vue&type=script&lang=ts"

import "./DriverStatusApiDocsPage.vue?vue&type=style&index=0&id=1cc1fc78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cc1fc78"]])

export default __exports__